var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightgreencheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "13px",
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A45717C3-1B57-411C-94F1-1915A826B63C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RiseIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Job-Postings",
    transform: "translate(-1519.000000, -185.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 1680,
    height: 1003
  }), /*#__PURE__*/React.createElement("g", {
    id: "Row-Sales",
    transform: "translate(223.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1454,
    height: 60
  }), /*#__PURE__*/React.createElement("g", {
    id: "pill-matched",
    transform: "translate(1292.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#80BD03",
    opacity: 0.253150577,
    x: 0,
    y: 0,
    width: 74,
    height: 24,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(4.484848, 6.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#80BD03",
    cx: 7.28787879,
    cy: 6.5,
    rx: 7.28787879,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61736069,3.74420568 C9.77575578,3.50693573 10.1198203,3.42911344 10.3858502,3.57038474 C10.6518802,3.71165605 10.7391354,4.01852436 10.5807404,4.25579432 L7.21609246,9.29591158 C7.02897848,9.57620135 6.59590414,9.6242016 6.33756174,9.39328445 L4.07758755,7.37322582 C3.85889641,7.17775061 3.85928393,6.86116831 4.0784531,6.66611946 C4.29762227,6.47107061 4.65257819,6.47141624 4.87126933,6.66689144 L6.62154965,8.231 L9.61736069,3.74420568 Z",
    id: "Line",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightgreencheck);
export default __webpack_public_path__ + "static/media/lightgreencheck.c2ffa8020e65fb04b4dab380d3650894.svg";
export { ForwardRef as ReactComponent };